import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const AccountDeletedRenderer = (props) => {
    switch (props.valueFormatted) {
        case 'true':
        case true:
            return <FontAwesomeIcon icon={faCircleXmark} style={{ color: "#e85454", height: '20px' }} />;
        case 'false':
        case false:
            return <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#a5c946", height: '20px' }} />;
        case 'not_valid':
            return <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#ff8000", height: '20px' }} />;
        default:
            return (<span>{props.value}</span>);
    }

}

export default AccountDeletedRenderer;